import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import supabase from 'modules/core/supabase/supabase';
import { ReceivedTime } from 'modules/overlay-v2/domain/interfaces/received-time';
import { getTime } from 'modules/overlay-v2/domain/utils/get-time';

const PREFIX = 'time';

export const resetTime = createAction(`${PREFIX}/resetTime`);

export const syncTime = createAsyncThunk<ReceivedTime, { matchId: number }>(
  `${PREFIX}/syncTime`,
  async (payload, { rejectWithValue }) => {
    try {
      return await getTime(payload.matchId);
    } catch (error) {
      console.error(`${PREFIX}/fetchUser error:`, error);

      let message;
      if (error instanceof Error) message = error.message;
      else message = String(error);

      supabase.overlayLogs.createError({ comment: 'Не удалось получить данные при синхронизации времени', message });
      return rejectWithValue(message);
    }
  },
);
